import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContent from "../../../layouts/maincontent/MainContent";
import UnifiedTaxDeclarationContext from "../../../contexts/UnifiedTaxDeclarationProvider";
import styles from "./SubmissionGuide.module.css";

const guideContent = `
مرحباً بك في الخدمات الضريبية الالكترونية لمصلحة الضرائب العقارية
صُمم تطبيق الهاتف المحمول والبوابة الالكترونية لمصلحة الضرائب العقارية لتكون بوابتك الذكية لإنجاز معاملاتك الضريبية بكل سهولة وأمان.
نسعى لتوفير كل التسهيلات التي تجعل تعاملاتك الضريبية تجربة سريعة وسلسه دون الحاجة الي التعامل مع المأموريات الضريبية وتضمن استفادتك من الحوافز والتسهيلات الضريبية المقررة قانوناً.

الخدمات المتاحة حالياً
    - إقرار ضريبة العقارات المبنية: قدّم إقرارك الضريبي للعقارات بخطوات سهلة وبسيطة، مع إمكانية حفظ المسودة والعودة إليها الحقاً وإمكانية تعديل البيانات خالل المدة القانونية لتقديم الإقرارات الضريبية وذلك لالستفادة من الحوافز المرتبطة بتقديم الإقرار الضريبي.
    - السداد الإلكتروني: تم اتاحة خدمة السداد الإلكتروني لقيمة الضريبة على العقارات المبنية عبر قنوات دفع آمنة ومتعددة، وفي هذه المرحلة يتم السداد عبر القنوات االتية:
        ▪ السداد عن طريق البنوك.
        ▪ السداد عبر نقاط البيع الحكومية (POS).
        ▪ وتم اتاحة نوعين من السداد وهم:
(أ) سداد تحت حساب الضريبة: سدّد قيمة محددة تحت حساب الضريبة بعد تقديم الإقرار، وذلك لالستفادة من الحافز بالخصم من الضريبة بما ال يجاوز 5%، ويتم تحديد المبالغ المطلوب سدادها تحت حساب الضريبة وفق قرار وزير المالية لسنة 2026.
(ب) سداد مديونيات سابقة: سدّد الضريبة المستحقة (عن متأخرات سنوات سابقة) وذلك لالستفادة من الحافز بالتجاوز عن مقابل التأخير خالل المدة القانونية المقررة.

خدمات قادمة تدريجياً
باقي الخدمات الضريبية (ومنها الطعن الضريبي، مستخرجات رسمية، ضريبة على غير القادرين، رفع الضريبة، رد الضريبة، التصالح الضريبي وغيرها) سيتم إطالقها على مراحل في التحديثات القادمة.
سنقوم بإشعارك فور توفر أي خدمة جديدة.

إرشادات تقديم إقرار ضريبة المباني وسداده
    1-	 يمكنك الاطلاع على الموقع كزائر. 
    2-	 للاستفادة من الخدمات قم بإنشاء حساب على تطبيق الهاتف المحمول أو الموقع الالكتروني للمصلحة (WWW.rta.gov.eg).
    3-	 من الشاشة الرئيسية اختر خدمة الإقرار الضريبي. 
    4-	 املأ البيانات المطلوبة وقم بتصوير بطاقة الرقم القومي او جواز السفر للأجانب للأشخاص الطبيعية، وصورة السجل التجاري للأشخاص الاعتبارية.
          ● يقصد بالشخص الطبيعي: الاشخاص الطبيعية هي الافراد وتنقسم الي نوعين: 
                  (أ): كامل الاهلية. 
                  (ب): ناقص الاهلية مثل القاصر وغيرة ويقر عنه من يمثله قانوناً (الولي / الوصي / القيم) بحسب الاحوال
          ● يقصد بالشخص الاعتباري نوعين: 
                  (أ): اشخاص اعتبارية عامة: مثل وحدات الإدارة المحلية والهيئات العامة والأجهزة التي لها موازنات خاصه.
                  (ب): اشخاص اعتبارية خاصة: مثل الشركات والجمعيات والنقابات وغيرها من الكيانات سواء كانت مملوكة للدولة ملكية خاصة او مملوكة للأفراد.

    5-	  ستصلك رسالة (OTP) على رقم الهاتف المحمول الشخصي الذي تم تحديده في البيانات وستنتهي صلاحيتها خلال 10دقائق. 
    6-	  قم بإدخال الرقم المرسل (OTP) وتسجيل الدخول وتفعيل حسابك. 
    7-	  ابدء في ملئ بيانات العقارات المبنية التي تمتلكها او تنتفع بها او تستغلها حتي وان كنت ضمن المستفيدين بالإعفاء الضريبي. 
    8-	  في حاله تعدد الوحدات المملوكة لك في ذات العقار سيتم اختيار إضافة وحدة في ذات العقار وسيتم ملء بعض الحقول المتعلقة بالعقار تلقائياً لتوفير وقتك.
    9-	  يتم اختيار موقع العقار من الخريطة الرقمية المتاحة على النظام، وتكرر هذه العملية مع ادخال كل وحدة بعقارات مختلفة، وفيما يتعلق بالمنشآت التي تتكون من أكثر من مبني مثل المصانع او الفنادق او المدارس او غيرها يراعي اختيار احد هذه المباني ليكون المبني الرئيسي ثم ادخال باقي المباني واختيار الموقع من الخريطة بدلاله اقرب عقار.  
    10-    عند عدم وجود عقارك على الخريطة يرجي تحديد أقرب عقار لحين تحديث الخريطة. 
    11-   تحديد العقار على الخريطة يهدف الي حصولك علي الرقم القومي العقاري الموحد وفي مرحلة لاحقة سيتاح الرقم القومي العقاري للوحدة والذي سيتم التعامل من خلاله مع كافة جهات الدولة فيما بعد.
    12-   للتيسير عليك تم اتاحة خدمة طلب الاعفاء الضريبي ضمن بيانات الإقرار حيث ستتمكن من تحديد الوحدة التي ترغب في اعفائها كسكن خاص وكذلك الحال في كافة الإعفاءات الأخرى المقررة بقانون الضريبة على العقارات المبنية او مقررة بموجب قوانين خاصة مع توضيح سبب الاعفاء. 
    13-   احرص على ارفاق المستندات الدالة على توافر إحدى حالات الاعفاء والمستندات الدالة على الملكية لضمان دقة البيانات وسرعه دراسة طلبات الاعفاء. 
    14-   متاح عبر التطبيق رسائل توضيحية لبيان شروط الاعفاء لكل حاله وقوائم بأهم المستندات التي يتم ارفاقها. 
    15-   متاح تقديم طلبات تحمل وزارة المالية الضريبة عن المنشآت الخدمية والإنتاجية طبقاً لقرار مجلس الوزراء رقم 61 لسنه 2022.  
    16-   راجع بيانات الإقرار الضريبي ثم اضغط " تقديم الإقرار" ولسهولة الاستخدام والمراجعة تم اتاحة ملخص الإقرار في عند طباعه الإقرار. 
    17-   متاح تعديل الإقرار الضريبي خلال المواعيد القانونية. 


بمجرد تقديمك الإقرار صحيح خلال الميعاد القانوني ومستوفياً كافة البيانات تكون قد استفد من الحافز المقرر لتقديم الإقرار والمتمثل بالخصم من الضريبة السنوية المستحقة بالنسب المقررة قانوناً وهي: 
    1-    الخصم بنسبة 25% للوحدات السكنية. 
    2-    الخصم بنسبة 10% للوحدات غير السكنية. 
بالإضافة الي العفو الضريبي عن الوحدات التي لم يسبق تسجيلها او الاخطار بها حيث سيتم محاسبتهم من تاريخ الإقرار ونبدأ صفحة جديدة وفقاً للشروط المحددة بالقانون.  
عند الانتهاء من تقديم الإقرار انتقل الي السداد للاستفادة من الحوافز المقررة لنوعي السداد واختر وسيلة الدفع المناسبة لإتمام العملية
أنواع السداد المتاحة والحوافز المرتبطة بكل نوع: 
  (أ) سداد تحت حساب الضريبة: 
      -   سدّد قيمة محددة تحت حساب الضريبة لكل وحدة تم الإقرار عنها وذلك بعد تقديم الإقرار لحين انتهاء اللجان من تقدير الضريبة المستحقة للاستفادة من الحافز المقرر بالخصم من الضريبة السنوية بنسبة 5%. 
      -   يتم تحديد القيمة الكترونياً من خلال النظام وفقاً للفئات الصادر بها قرار من وزير المالية.  
      -   السداد تحت حساب الضريبة متاح خلال فترة تقديم الإقرار الضريبة فقط. 
      -   في حاله تقديم طلب رد للمبلغ المسدد يكون الحافز ملغي وغير مستحق. 

  (ب) سداد مديونيات سابقة:
      -   سدّد الضريبة المستحقة (المتأخرات عن سنوات سابقة) وذلك للاستفادة من الحافز المقرر بالتجاوز عن مقابل التأخير خلال المدة القانونية. 
ملاحظات عامة:
    - 	جميع ايصالات السداد الالكترونية المستخرجة من النظام تتمتع بالحجية القانونية في اثبات السداد امام الكافة.
    -	  يتم احتساب الحوافز والخصومات تلقائيًا من خلال المنظومة الإلكترونية حال توافر شروطها ويظهر أثر الخصم ضمن بيان حساب الضريبة ولا يتطلب ذلك تقديم طلب مستقل ولا يعتد بأي إجراء أو سداد يتم بعد انقضاء المواعيد او خارج النظام وقنوات السداد المعتمدة .
    -	  في حالة السداد تحت حساب الضريبة للاستفادة من الحوافز الضريبية ثم الاعتراض البنكي على هذه المدفوعة واستردادها يسقط حقك في الاستفادة من التيسيرات الضريبية المقررة بالسداد تحت الحساب. 
نصائح مهمة: 
    ✓	أدخل بيانات صحيحة ودقيقة للاستفادة من الحوافز.
    ✓	لا تشارك كلمة المرور مع أي شخص.
    ✓	احتفظ بكلمة المرور الخاصة بك والمكونة من حروف وأرقام باللغة الإنجليزية. 
    ✓	تابع طلباتك باستمرار من خلال حسابك. 
    ✓	يجوز لك الاحتفاظ بنسخة إلكترونية أو ورقية من الإقرار الضريبي وايصالات السداد الالكترونية بالإضافة الي بيان تفصيلي بالمبالغ المسددة عن كل وحدة. 
    ✓	كن حريص على الاستفادة من الحوافز والتسهيلات المقررة قانونًا، وهي: 
    -	الخصم من قيمة الضريبة المستحقة عند تقديم الإقرار. 
    -	 الخصم الإضافي عند السداد تحت حساب الضريبة.
    -	 الاستفادة من العفو الضريبي عند تقديم الإقرار وعدم المحاسبة عن السنوات السابقة. 
    -	الاستفادة من التصالح وحسم المنازعات القائمة. 
    -	التجاوز عن مقابل التأخير. 
وذلك وفقًا للضوابط والشروط والمواعيد المحددة بالقانون لكل حالة.
  ■ متى تحتاج لتحديث بياناتك؟
    ✓ عند بيع العقار/الوحدة ستحتاج الي تقديم طلب لإزالته من حسابك لتجنب المطالبات الضريبية عن العقار. 
    ✓	عند شراء عقار/ وحدة جديد ستحتاج الي تقديم الإقرار الضريبي للاستفادة من الحوافز.
    ✓	عند تغيير الاستخدام من سكني الي غير سكني او العكس. 
    ✓	عند ادخال تعديلات جوهرية بضم وحدات او تقسيمها. 
    ✓	عند زوال سبب الاعفاء. 
■ تذكير مهم
    ✓	الالتزام بالمواعيد المحددة لتقديم الإقرارات للاستفادة من الحافز وضمان استمراره ويجنبك العقوبات المقررة بالقانون.  
    ✓	الالتزام بالمواعيد المحددة لسداد الضريبة سنوياً وإتاحة سدادها على أقساط شهرية للتيسير وتجنب احتساب مقابل التأخير.
    ✓	الالتزام يحميك من مقابل التأخير ويضمن استفادتك من أي حوافز أو إعفاءات.
    ✓	تذكر أن التسهيلات والحوافز تخضع لأحكام القانون والقرارات المنظمة.
    ✓	 يتم تحديث النظام تلقائيًا بأي تعديلات او خدمات جديدة لذلك احرص دائما على متابعه حسابك الالكتروني بصفة دورية. 
■ تسهيلات ذكية تدعمك: 
    ✱	تنبيهات المواعيد: نذكّرك بتواريخ تقديم الإقرارات ومواعيد السداد.
    ✱	حفظ المسودات: اعمل إقراراتك على مراحل دون خسارة البيانات واحرص على عدم تجاوز المدة القانونية لتقديم الإقرار.
    ✱	الاخطارات الالكترونية: ستصلك كافة الاخطارات والمطالبات عبر بريدك الالكتروني والرسائل النصية.
    ✱	الدعم الفني المباشر: فريقنا جاهز للإجابة عن استفساراتك والتعامل مع أي مشكلة تقنية قد تواجهك اثناء استخدام التطبيق وذلك من خلال الاتصال برقم .......
تستهدف المنظومة الإلكترونية تيسير إجراءات الامتثال الضريبي وتحفيز الممولين الملتزمين من خلال إتاحة الحوافز بشكل مميكن وعادل يحقق الشفافية وتكافؤ الفرص.

نشكر ثقتكم، وترقّبوا المزيد من الخدمات قريباً.
`;

const highlightedTitles = new Set([
  "مرحباً بك في الخدمات الضريبية الالكترونية لمصلحة الضرائب العقارية",
  "ملاحظات عامة:",
  "نصائح مهمة:",
  "■ تذكير مهم",
  "■ تسهيلات ذكية تدعمك:",
  "بمجرد تقديمك الإقرار صحيح خلال الميعاد القانوني ومستوفياً كافة البيانات تكون قد استفد من الحافز المقرر لتقديم الإقرار والمتمثل بالخصم من الضريبة السنوية المستحقة بالنسب المقررة قانوناً وهي:",
  "عند الانتهاء من تقديم الإقرار انتقل الي السداد للاستفادة من الحوافز المقررة لنوعي السداد واختر وسيلة الدفع المناسبة لإتمام العملية",
"وذلك وفقًا للضوابط والشروط والمواعيد المحددة بالقانون لكل حالة.",
"متى تحتاج لتحديث بياناتك؟",
"تستهدف المنظومة الإلكترونية تيسير إجراءات الامتثال الضريبي وتحفيز الممولين الملتزمين من خلال إتاحة الحوافز بشكل مميكن وعادل يحقق الشفافية وتكافؤ الفرص." ,
"■ متى تحتاج لتحديث بياناتك؟",
"● يقصد بالشخص الطبيعي: الاشخاص الطبيعية هي الافراد وتنقسم الي نوعين:",
"● يقصد بالشخص الاعتباري نوعين:",
"(أ) سداد تحت حساب الضريبة:",
"(ب) سداد مديونيات سابقة:"

]);

const underlinedPhrases = new Set([
  "الخدمات المتاحة حالياً",
  "خدمات قادمة تدريجياً",
  "إرشادات تقديم إقرار ضريبة المباني وسداده",
    "أنواع السداد المتاحة والحوافز المرتبطة بكل نوع:",
    
]);

function UnifiedTaxDeclarationSubmissionGuide() {
  const navigate = useNavigate();
  const { updateDeclarationRequest } = useContext(UnifiedTaxDeclarationContext);
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const guideLines = guideContent
    .split("\n")
    .filter((line) => line.trim() !== "");

  useEffect(() => {
    localStorage.removeItem("terms_conditions");
  }, []);

  const handleMoveToSubmit = () => {
    if (!isAcknowledged) {
      setErrorMessage(
        "يجب أن تقر بالإطلاع على الإرشادات و قراءة ضوابط تقديم الإقرار قبل البدء في إنشاءه و الموافقة على ذلك",
      );
      return;
    }

    updateDeclarationRequest("terms_conditions", true);
    localStorage.setItem("terms_conditions", true);
    navigate("/tax-declaration/add");
  };

  return (
    <MainContent>
      <section className={styles.guidePage}>
        <div className="container py-4">
          <div className={styles.card}>
            <h2 className={styles.title}>
              الدليل الإرشادي لتقديم الإقرار الضريبي
            </h2>
            <p className={styles.subtitle}>
              الرجاء قراءة الخطوات والملاحظات التالية بعناية قبل البدء في تقديم
              الإقرار.
            </p>

            <div className={styles.content} dir="rtl">
              <div className={styles.preformatted}>
                {guideLines.map((line, index) => {
                  const text = line.trim();
                  const isTitle = highlightedTitles.has(text);
                  const isUnderlined = underlinedPhrases.has(text);

                  return (
                    <p
                      key={index}
                      className={
                        isTitle ? styles.innerTitle : isUnderlined ? styles.underlinedLine : styles.normalLine
                      }
                    >
                      {line}
                    </p>
                  );
                })}
              </div>
            </div>

            <div className={styles.actionsSection}>
              <label className={styles.checkboxLabel}>
                <input
                className="form-check-input m-1 "
                  type="checkbox"
                  checked={isAcknowledged}
                  onChange={(e) => {
                    setIsAcknowledged(e.target.checked);
                    if (e.target.checked) {
                      setErrorMessage("");
                    }
                  }}
                />
                <span className={styles.requiredAsterisk}>*</span>
                <span>
                  أقر بالإطلاع على الإرشادات و قراءة ضوابط تقديم الإقرار قبل
                  البدء في إنشاءه و الموافقة على ذلك
                </span>
              </label>

              {errorMessage && <p className={styles.error}>{errorMessage}</p>}

              <div className={styles.buttonsRow}>
                <button
                  type="button"
                  className={styles.primaryButton}
                  onClick={handleMoveToSubmit}
                >
                  الإنتقال إلى تقديم إقرار
                </button>

                <button
                  type="button"
                  className={styles.secondaryButton}
                  onClick={() => navigate("/tax-declaration/list-data")}
                >
                  العودة
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default UnifiedTaxDeclarationSubmissionGuide;
